import { render, staticRenderFns } from "./HealthProfessionalProfile.vue?vue&type=template&id=ffe9804a&scoped=true&"
import script from "./HealthProfessionalProfile.vue?vue&type=script&lang=js&"
export * from "./HealthProfessionalProfile.vue?vue&type=script&lang=js&"
import style0 from "./HealthProfessionalProfile.vue?vue&type=style&index=0&id=ffe9804a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe9804a",
  null
  
)

export default component.exports